import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.originalText = this.buttonTarget.textContent
  }

  handleClick(event) {
    event.preventDefault()
    
    // Add transition effect
    this.buttonTarget.style.transition = "all 0.3s ease"
    this.buttonTarget.style.transform = "scale(0.95)"
    
    // Change text with animation
    setTimeout(() => {
      this.buttonTarget.textContent = "Coming soon..."
      this.buttonTarget.style.transform = "scale(1)"
      this.buttonTarget.style.opacity = "0.8"
      this.buttonTarget.style.textDecoration = "none"
    }, 150)
  }
}
